<template>
  <div class="page" :class="{ 'page__has-bar': true }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <em class="weui-form-preview__value">{{initData.custName}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户料号</label>
            <em class="weui-form-preview__value">{{initData.prodCode}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <em class="weui-form-preview__value">{{initData.prodName}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品规格</label>
            <em class="weui-form-preview__value">{{initData.prodOrispeccode}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品型号</label>
            <em class="weui-form-preview__value">{{initData.prodSpec}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <em class="weui-form-preview__value">{{initData.prodBrand}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <em class="weui-form-preview__value">{{initData.needQty}} {{initData.prodUnit}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <em class="weui-form-preview__value">
              {{initData.userName}}
              <call-mobile :mobile="initData.userTel"></call-mobile>
            </em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">商机编号</label>
            <em class="weui-form-preview__value">{{initData.inquiryCode}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">发布日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.startDate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">截止日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.endDate}}</span>
          </div>
          <file-list v-model="initData.sourceAttach" />
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!initData.quId">
      <div class="weui-dialog__btn weui-dialog__btn_primary" @click="quote">发起报价</div>
    </div>
  </div>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";
import FileList from "@/components/FileList.vue";

export default {
  components: {
    CallMobile,
    FileList
  },
  props: {
    initData: Object
  },
  mounted() {
    if(this.initData.quId)this.$router.push("/sale/quote/" + this.initData.quId);
  },
  methods: {
    quote() {
      let me = this
      me.$loading({
        url: '/api/sale/sale/enterprise/saleBusToQuotation',
        method: 'POST',
        jsonData: me.initData
      }).then(function(res) {
        if(res.success) {
          me.$router.push("/sale/quote/" + res.data.id);
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      })
    }
  }
};
</script>